import { Component, Input } from '@angular/core';
import { EntityFormOptions } from '@common/classes/entity-form';
import { AppControlType } from '@common/components/app-control/app-control.component';
import { User } from '@common/models/User';

@Component({
    selector: 'app-vessel-notification-pilot',
    templateUrl: './vessel-notification-pilot.component.html',
    styleUrls: ['./vessel-notification-pilot.component.scss']
})
export class VesselNotificationPilotComponent {
    @Input() model: any;
    @Input() canEdit: boolean;
    @Input() editMode: any;
    @Input() user: User;

    formOptions: EntityFormOptions = {
        entityName: 'VesselNotificationPilot',
        canEdit: () => this.canEdit && this.editMode,
        propertyGroups: [
            [
                {
                    name: 'pilotOrganizationId',
                    label: 'Pilot Organization',
                    type: AppControlType.CodeList,
                    codelist: 'Pilot',
                    colSize: 4
                },
                {
                    name: 'pilotEta',
                    label: 'ETA Pilot Station',
                    type: AppControlType.DateTime,
                    time: true,
                    colSize: 4
                }
            ]
        ]
    };
}
